module.exports = __webpack_public_path__ + "img/code-html-md.7cbb810b.webp";